import { useState,useEffect } from "react"
import firebase from "gatsby-plugin-firebase"

//a hook that will update whenever the user logs in or out
export default () => {
    const [user, setUser] = useState()
  
    useEffect(() => {
      firebase.auth().onAuthStateChanged(firebaseUser => {
        setUser(firebaseUser)
      })
    }, [])
  
    return user
  }